// extracted by mini-css-extract-plugin
module.exports = {"base":"ProjectDetailsTabs_base__1FiC8","tabPane":"ProjectDetailsTabs_tabPane__3sEKt"};